import { render, staticRenderFns } from "./NormalizedReportChip.vue?vue&type=template&id=a74c78de"
import script from "./NormalizedReportChip.vue?vue&type=script&lang=js"
export * from "./NormalizedReportChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports